import React, { Component, Fragment } from 'react';
import { Redirect, Route } from 'react-router-dom';
import { Home } from './components/Home';
import { DetailsListAlarme } from './components/List/DetailsListAlarme';
import { DetailsListAPI } from './components/List/DetailsListAPI';
import { DetailsListAppelDeFonds } from './components/List/DetailsListAppelDeFonds/DetailsListAppelDeFonds';
import { DetailsListCapsuleClient } from './components/List/DetailsListCapsuleClient';
import { DetailsListCGPrevision } from './components/List/DetailsListCGPrevision';
import { DetailsListCGRecapitulatif } from './components/List/DetailsListCGRecapitulatif';
import { DetailsListCGReintegration } from './components/List/DetailsListCGReintegration';
import { DetailsListCGValidation } from './components/List/DetailsListCGValidation';
import { DetailsListChampMetier } from './components/List/DetailsListChampMetier';
import { DetailsListChecklist } from './components/List/DetailsListChecklist';
import { DetailsListCompte } from './components/List/DetailsListCompte';
import { DetailsListContact } from './components/List/DetailsListContact';
import { DetailsListContratDeReservation } from './components/List/DetailsListContratDeReservation';
import { DetailsListContratsElectroniques } from './components/List/DetailsListContratsElectroniques';
import { DetailsListDemande } from './components/List/DetailsListDemande';
import { DetailsListDenonciation } from './components/List/DetailsListDenonciation';
import { DetailsListDocument } from './components/List/DetailsListDocument';
import { DetailsListDroit } from './components/List/DetailsListDroit';
import { DetailsListEcheancier } from './components/List/DetailsListEcheancier';
import { DetailsListFluxPartenaire } from './components/List/DetailsListFluxPartenaire';
import { DetailsListJournalisation } from './components/List/DetailsListJournalisation';
import { DetailsListMandat } from './components/List/DetailsListMandat';
import { DetailsListMandatAlerte } from './components/List/DetailsListMandatAlerte';
import { DetailsListNews } from './components/List/DetailsListNews';
import { DetailsListNewsLecture } from './components/List/DetailsListNewsLecture';
import { DetailsListNotificationPush } from './components/List/DetailsListNotificationPush';
import { DetailsListOperation } from './components/List/DetailsListOperation';
import { DetailsListOrigineContact } from './components/List/DetailsListOrigineContact';
import { DetailsListRepartiteur } from './components/List/DetailsListRepartiteur';
import { DetailsListReporting } from './components/List/DetailsListReporting';
import { DetailsListSocieteAPI } from './components/List/DetailsListSocieteAPI';
import { DetailsListSocieteNotificationPush } from './components/List/DetailsListSocieteNotificationPush';
import { DetailsListSouhait } from './components/List/DetailsListSouhait';
import { DetailsListSouhaitMaisonIndividuelle } from './components/List/DetailsListSouhaitMaisonIndividuelle';
import { DetailsListTache } from './components/List/DetailsListTache';
import { DetailsListTicket } from './components/List/DetailsListTicket';
import { DetailsListVente } from './components/List/DetailsListVente/DetailsListVente';
import { ADV } from './components/Page/ADV';
import { Alarme } from './components/Page/Alarme';
import { BackOffice } from './components/Page/BackOffice';
import { BackOfficeCapsuleClient } from './components/Page/BackOfficeCapsuleClient';
import { Configuration } from './components/Page/Configuration';
import { ControleDeGestion } from './components/Page/ControleDeGestion';
import { Document } from './components/Page/Document';
import { DossierClientType } from './components/Page/DossierClientType';
import { GestionAPIs } from './components/Page/GestionAPIs';
import { GestionSignature } from './components/Page/GestionSignature';
import { GrilleDePrix } from './components/Page/GrilleDePrix';
import { IdentificationOperation } from './components/Page/IdentificationOperation';
import { IdentificationProgramme } from './components/Page/IdentificationProgramme';
import { ImportExport } from './components/Page/ImportExport';
import { Mandat } from './components/Page/Mandat';
import { MandatCommercialisation } from './components/Page/MandatCommercialisation';
import { News } from './components/Page/News';
import { Operation } from './components/Page/Operation';
import { Prospection } from './components/Page/Prospection';
import { Reporting } from './components/Page/Reporting';
import { Reservation } from './components/Page/Reservation';
import { SignatureEiffage } from './components/Page/SignatureEiffage';
import { TableauDeBord } from './components/Page/TableauDeBord';
import { Vente } from './components/Page/Vente';
import PerimetreContext from './contexts/PerimetreContext';
/* 20230601 : YD : 2421*/
import { DetailsListActualite } from './components/List/DetailsListActualite';

export default class Router extends Component {

    static contextType = PerimetreContext;

    constructor(props) {
        super(props);
        this.state = { perimetreChange: false };
    };

    render = () => {

        const { perimetre } = this.context;

        return <Fragment>

            <Route exact path='/' component={Home} />

            <Route path='/Configuration' component={Configuration} />
            <Route path='/Configuration/ListeTaches' component={DetailsListTache} />

            <Route path='/Configuration/ListeTickets/:mode/:valeur' component={DetailsListTicket} />
            <Route path='/Configuration/ListeTicketsByEtat/:mode/:valeur' component={DetailsListTicket} />
            <Route path='/Configuration/ListeTicketsByAAffecter/:mode/:valeur' component={DetailsListTicket} />

            <Route path='/Configuration/ListeComptes' component={DetailsListCompte} />
            <Route path='/Configuration/ListeNews' component={DetailsListNews} />
            <Route path='/Configuration/ListeJournalisations' component={DetailsListJournalisation} />
            <Route path='/Configuration/ListeDroits' component={DetailsListDroit} />
            <Route path='/Configuration/GestionAPIs' component={GestionAPIs} />
            <Route path='/Configuration/GestionAPIs/ListeAPIs' component={DetailsListAPI} />
            <Route path='/Configuration/GestionAPIs/ListeNotificationsPush' component={DetailsListNotificationPush} />
            <Route path='/Configuration/GestionAPIs/ListeSocietesAPIs' component={DetailsListSocieteAPI} />
            <Route path='/Configuration/GestionAPIs/ListeSocietesNotificationsPush' component={DetailsListSocieteNotificationPush} />
            <Route path='/Configuration/GestionAPIs/ListeFluxPartenaires' component={DetailsListFluxPartenaire} />
            <Route path='/Configuration/GestionPublipostage' component={DetailsListChampMetier} />
            <Route path='/Configuration/GestionSignature' component={GestionSignature} />
            <Route path='/Configuration/GestionContratsElectroniques' component={DetailsListContratsElectroniques} />

            <Route path='/Prospection' component={Prospection} />
            <Route path='/Prospection/ListeContacts' component={DetailsListContact} />
            <Route path='/Prospection/ListeSouhaits' component={DetailsListSouhait} />
            <Route path='/Prospection/ListeDenonciations' component={DetailsListDenonciation} />
            <Route path='/Prospection/ListeSouhaitsMaisonsIndividuelles' component={DetailsListSouhaitMaisonIndividuelle} />
            <Route path='/Prospection/ListeOriginesContacts' component={DetailsListOrigineContact} />
            <Route path='/Prospection/ListeRepartiteurs' component={DetailsListRepartiteur} />

            <Route path='/Vente' component={Vente} />
            <Route path='/Vente/EspaceDeVente/:Version/:Numero' component={DetailsListVente} />

            <Route path='/Mandat' component={Mandat} />
            <Route path='/Mandat/ListeMandatsSociete/:Mode/:Valeur' component={DetailsListMandat} />
            <Route path='/Mandat/ListeMandatsEiffage/:Mode/:Valeur' component={DetailsListMandat} />
            <Route path='/Mandat/ListeMandatsWS/:Mode/:Valeur' component={DetailsListMandat} />
            <Route path='/Mandat/GestionAlertes' component={DetailsListMandatAlerte} />

            <Route path='/Reporting' component={Reporting} />
            <Route path='/Reporting/ListeRapports' component={DetailsListReporting} />

            <Route path='/TableauDeBord' component={TableauDeBord} />

            <Route path='/Operations' component={Operation} />
            <Route path="/Operations/ListeOperations" render={props => <DetailsListOperation {...props} majPerimetre={(value) => this.setState({ perimetreChange: value })} />} />
            <Route path='/Operations/IdentificationProgramme' component={IdentificationProgramme} />
            <Route path='/Operations/IdentificationOperation' component={IdentificationOperation} />
            <Route path='/Operations/GrilleDePrix' component={GrilleDePrix} />
            <Route path='/Operations/ImportExport' component={ImportExport} />
            <Route path='/Operations/DossierClientType' component={DossierClientType} />
            <Route path='/Operations/MandatCommercialisation' component={MandatCommercialisation} />

            <Route path='/Documents' component={Document} />
            <Route path='/Documents/GestionDocuments' component={DetailsListDocument} />

            {/* }<Route path='/ControleDeGestion' component={ControleDeGestion} />*/}
            <Route path='/ControleDeGestion' render={props => <ControleDeGestion {...props} periodeOuverte={this.state.periodeOuverte} />} />
            <Route path='/ControleDeGestion/Recapitulatif' render={props => <DetailsListCGRecapitulatif {...props} onOuverturePeriode={() => this.setState({ periodeOuverte: true })} />} />
            {/* <Route path='/ControleDeGestion/Recapitulatif' component={DetailsListCGRecapitulatif} /> */}
            <Route path='/ControleDeGestion/Validation' component={DetailsListCGValidation} />
            <Route path='/ControleDeGestion/Reintegration' component={DetailsListCGReintegration} />
            <Route path='/ControleDeGestion/Previsions' component={DetailsListCGPrevision} />

            <Route path='/News' component={News} />
            <Route path='/News/ListeNews' component={DetailsListNewsLecture} />

            <Route path='/Reservation/:IdOperation/:IdReservation' component={Reservation} />

            <Route path='/BackOfficeCapsuleClient' component={BackOfficeCapsuleClient} />
            <Route path='/BackOfficeCapsuleClient/CapsuleClient' component={DetailsListCapsuleClient} />
            {/* 20230601 : YD : 2421*/}
            <Route path='/BackOfficeCapsuleClient/Actualites' component={DetailsListActualite} />

            <Route path='/BackOffice' component={BackOffice} />
            <Route path='/BackOffice/Checklists' component={DetailsListChecklist} />
            <Route path='/BackOffice/Demandes' component={DetailsListDemande} />

            <Route path='/Alarmes' component={Alarme} />
            <Route path='/Alarmes/GestionDesAlarmes' render={props => <DetailsListAlarme {...props} activerCreation={false} afficherAlarmesLieesASouhaits afficherAlarmesLieesACapsules afficherAlarmesLieesADemandes />} />
            <Route path='/Alarmes/Souhaits' render={props => <DetailsListAlarme {...props} activerCreation={false} activerFiltres={false} afficherAlarmesLieesASouhaits />} />
            <Route path='/Alarmes/Capsules' render={props => <DetailsListAlarme {...props} activerCreation={false} activerFiltres={false} afficherAlarmesLieesACapsules />} />

            <Route path='/SignaturesEiffage' component={SignatureEiffage} />
            <Route path='/SignaturesEiffage/ContratsDeReservations' component={DetailsListContratDeReservation} />

            <Route path='/ADV' component={ADV} />
            <Route path='/ADV/AppelsDeFonds' render={props => <DetailsListAppelDeFonds {...props} perimetre={perimetre} />} />
            <Route path='/ADV/Echeanciers' render={props => !!perimetre.idOperation
                ? <DetailsListEcheancier {...props} idOperation={perimetre.idOperation} />
                : <Redirect to='/ADV' />
            } />

        </Fragment>;

    };

};